import React from "react";
import { Button } from "@procore/core-react";
import { Filter } from "@procore/core-icons";

interface BoardsFilterPanelButtonProps {
   isOpen: boolean;
   onToggle: () => void;
}

export function BoardsFilterPanelButton({ isOpen, onToggle }: BoardsFilterPanelButtonProps) {
   return (
      <Button
         variant="tertiary"
         icon={<Filter size="sm" />}
         onClick={onToggle}
         className={isOpen ? "controlPanelButtonActive" : ""}
      />
   );
}
